import React from 'react'

export const IconFail = () => {
  return <img src="https://icongr.am/clarity/times.svg?size=24&amp;color=d43939" alt="icon" />
}
